// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"b64b097f","879":"c7097359"}[chunkId] + ".chunk.css";
};